import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventGuestsResponseModel} from './edit-guests.model';
import {EditGuestsService} from './edit-guests.service';
import {ExcelService} from '../../../shared/services/excel-service.service';

@Component({
  selector: 'app-edit-guests',
  templateUrl: './edit-guests.component.html',
  styleUrls: ['./edit-guests.component.less'],
  providers: [EditGuestsService, ExcelService]
})
export class EditGuestsComponent implements OnInit {
  @Input() eventId: number;
  @Input() eventName: string;
  @Output() showGuestsClosed = new EventEmitter<boolean>();
  guests: EventGuestsResponseModel;
  showDelete = false;
  showEditGuest = false;
  activeTab = 1;
  deleteMember = null;
  deleteMemberGuest = null;
  selectedMemberForEdit = null;
  saveEnabled = true;
  searchString = '';

  showExportConfirmation = false;
  initialState: string;

  guestsCount: number;
  waitingListCount: number;
  showCloseGuestConfirm: boolean;

  constructor(private service: EditGuestsService, private excelService: ExcelService) {
  }

  ngOnInit() {
    this.service.getEventGuests(this.eventId).subscribe((r) => {
      this.guests = r;
      console.log(r);
      this.SaveInitialState();
      this.recalculateGuestsCount();
    });
  }

  deleteGuest(member, guest) {
    this.deleteMember = member;
    this.deleteMemberGuest = guest;

    this.showDelete = true;
  }

  deleteGuestConfirmed() {
    const source = this.activeTab === 1 ? this.guests['guestList'] : this.guests['waitingList'];
    if (!this.deleteMemberGuest) {
      source.splice(source.indexOf(this.deleteMember), 1);
    } else {
      this.deleteMember.guests.splice(this.deleteMember.guests.indexOf(this.deleteMemberGuest), 1);
    }
    this.showDelete = false;

    this.recalculateGuestsCount();
  }


  addOrEditGuest(guest) {
    this.selectedMemberForEdit = guest;
    this.showEditGuest = true;
  }

  closePopUp() {
    this.showDelete = false;
    this.showEditGuest = false;
    this.showExportConfirmation = false;
    this.showCloseGuestConfirm = false;
  }

  addGuestConfirmed(newGuest) {
    const source = this.activeTab === 1 ? this.guests['guestList'] : this.guests['waitingList'];
    source.unshift(newGuest);
    this.closePopUp();
    this.recalculateGuestsCount();
  }

  checkSearch() {
    if (this.searchString === '') {
      const source = this.activeTab === 1 ? this.guests['guestList'] : this.guests['waitingList'];
      for (let i = 0; i < source.length; i++) {
        source[i].expanded = false;
      }

    }
  }

  addWaitingListToGuest() {
    for (let i = 0; i < this.guests.waitingList.length;) {
      if (this.guests.waitingList[i].checked) {
        this.guests.waitingList[i].checked = false;
        this.guests.waitingList[i].expanded = false;
        this.guests.guestList.unshift(this.guests.waitingList[i]);
        const index = this.guests.waitingList.indexOf(this.guests.waitingList[i]);
        this.guests.waitingList.splice(index, 1);
      } else {
        i++;
      }
    }

    this.recalculateGuestsCount();

  }

  saveAndExport() {
    this.saveEnabled = false;
    this.service.updateEventGuests(this.guests).subscribe((r) => {
      this.exportLatest();
    }, (e) => {
      this.saveEnabled = true;
      this.showExportConfirmation = false;
    });
  }

  exportToExcel() {
    // Export never saves on its own: a list left open saved everyone who booked since it was opened
    // out of the event. Unsaved changes are saved only if the admin says so.
    if (this.StateChanged()) {
      this.showExportConfirmation = true;
    } else {
      this.exportLatest();
    }
  }

  recalculateGuestsCount() {
    if (this.guests) {
      this.guestsCount = 0;
      this.waitingListCount = 0;
      if (this.guests.guestList) {
        for (let i = 0; i < this.guests.guestList.length; i++) {
          this.guestsCount += 1;
          if (this.guests.guestList[i].guests) {
            this.guestsCount += this.guests.guestList[i].guests.length;
          }
        }
      }
      if (this.guests.waitingList) {
        for (let i = 0; i < this.guests.waitingList.length; i++) {
          this.waitingListCount += 1;
          if (this.guests.waitingList[i].guests) {
            this.waitingListCount += this.guests.waitingList[i].guests.length;
          }
        }
      }
    }
  }

  getGuests(): any[] {
    if (this.guests) {
      const r = [];
      if (this.guests.guestList) {
        for (let i = 0; i < this.guests.guestList.length; i++) {
          r.push({
            Name: this.guests.guestList[i].guestName,
            Email: this.guests.guestList[i].guestEmail,
            ApplicationTime: new Date(this.guests.guestList[i].reservationTime).toLocaleString()
          });
          if (this.guests.guestList[i].guests) {
            for (let j = 0; j < this.guests.guestList[i].guests.length; j++) {
              r.push({
                Name: this.guests.guestList[i].guests[j].guestName,
                Email: this.guests.guestList[i].guests[j].guestEmail,
                ApplicationTime: new Date(this.guests.guestList[i].guests[j].reservationTime).toLocaleString()

              });
            }
          }
        }
      }
      if (r.length === 0) {
        return [{Name: ' ', Email: ' ', ApplicationTime: ' '}];
      }
      return r;
    }
    return [{Name: '', Email: '', ApplicationTime: ''}];
  }

  getWaitingList(): any[] {
    if (this.guests) {
      const r = [];
      if (this.guests.waitingList) {
        for (let i = 0; i < this.guests.waitingList.length; i++) {
          r.push({
            Name: this.guests.waitingList[i].guestName,
            Email: this.guests.waitingList[i].guestEmail,
            ApplicationTime: new Date(this.guests.waitingList[i].reservationTime).toLocaleString()
          });
          if (this.guests.waitingList[i].guests) {
            for (let j = 0; j < this.guests.waitingList[i].guests.length; j++) {
              r.push({
                Name: this.guests.waitingList[i].guests[j].guestName,
                Email: this.guests.waitingList[i].guests[j].guestEmail,
                ApplicationTime: new Date(this.guests.waitingList[i].guests[j].reservationTime).toLocaleString()
              });
            }
          }
        }
      }
      if (r.length === 0) {
        return [{Name: ' ', Email: ' ', ApplicationTime: ' '}];
      }
      return r;
    }
    return [{Name: ' ', Email: ' ', ApplicationTime: ' '}];
  }

  save(closePopups = false) {
    this.saveEnabled = false;
    // if (closePopups) {
    //   this.closePopUp();
    // }
    this.service.updateEventGuests(this.guests).subscribe((r) => this.closeConfirmed(true), (e) => this.saveEnabled = true);

  }


  close(refresh = false) {
    if (this.StateChanged()) {
      this.showCloseGuestConfirm = true;
    } else {
      this.closeConfirmed(refresh);
    }
  }

  closeConfirmed(refresh) {
    this.closePopUp();
    this.showGuestsClosed.emit(refresh);
  }

  // Exports the list as saved right now, not as this screen loaded it, so the file includes bookings made
  // while the screen was open. The screen shows the same fresh list afterwards.
  private exportLatest() {
    this.saveEnabled = false;
    this.service.getEventGuests(this.eventId).subscribe((r) => {
      this.guests = r;
      this.SaveInitialState();
      this.recalculateGuestsCount();

      this.excelService.exportAsExcelFile([this.getGuests(), this.getWaitingList()],
        ['Guests', 'Waiting List'], this.eventName + ' - guests list');

      this.saveEnabled = true;
      this.showExportConfirmation = false;
    }, (e) => {
      this.saveEnabled = true;
      this.showExportConfirmation = false;
    });
  }

  private SaveInitialState() {
    this.initialState =
      JSON.stringify(this.guests);
  }

  private StateChanged() {
    const currentState =
      JSON.stringify(this.guests);
    return currentState !== this.initialState || currentState.length !== this.initialState.length;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/edit-guests/edit-guests.component.ts